import { X } from "react-feather";

const MobileFilter = ({
  isOpen,
  onClose,
  filters,
  applyFilters,
  clearFilters,
  renderCategoryFilter,
  renderPriceFilter,
  renderDiscountFilter,
  renderFilterGroup,
  
}) => {
  return (
    <div className={`mobile-filter-modal ${isOpen ? "open" : ""}`}>
      <div className="mobile-filter-header">
        <h4>Filters</h4>
        <X size={22} onClick={onClose} />
      </div>

      <div className="mobile-filter-body">
        {filters?.categories &&
          renderCategoryFilter(filters.categories, true)}

        {filters?.price_filter &&
          renderPriceFilter(filters.price_filter, true)}

        {filters?.discount_filter &&
          renderDiscountFilter(filters.discount_filter, true)}

        {filters?.product_filter &&
          Object.entries(filters.product_filter)
            .filter(([_, v]) => v.length)
            .map(([key, values]) =>
              renderFilterGroup(
                key.replace(/_/g, " "),
                values,
                key,
                true
              )
            )}
      </div>

      <div className="mobile-filter-footer">
        <button  className="apply-filter-btn-clr" onClick={clearFilters}>CLEAR ALL</button>
        <button  className="apply-filter-btn" onClick={applyFilters}>APPLY</button>
      </div>
    </div>
  );
};

export default MobileFilter;